// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1CE_9","custom":"kfijI"};